import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  Button,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { isMissingDeclaration } from 'typescript';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import { safeFalsy, safeEval } from '../../util/UtilFunctions';
import { CustomTable } from '../../common/CustomTable';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';

function SimpleDialog(props) {
  const { onClose, selectedRow, open } = props;
  const [loading, setLoading] = useState(true);
  const [missingItems, setMissingItems] = useState([]);

  const handleClose = () => {
    onClose();
    setLoading(true);
    setMissingItems([]);
  };

  const findMissing = x => {
    const {
      IsMissingAccount,
      IsMissingCategory,
      IsMissingContact,
      IsMissingCreditNote,
      IsMissingOverpayment,
      IsMissingPayment,
      IsMissingPrepayment,
    } = x;
    const m = {
      Account: IsMissingAccount,
      Category: IsMissingCategory,
      Contact: IsMissingContact,
      Credit_Note: IsMissingCreditNote,
      Overpayment: IsMissingOverpayment,
      Payment: IsMissingPayment,
      Prepayment: IsMissingPrepayment,
    };
    const payload = [];
    Object.entries(m).forEach(([key, val]) => {
      val === 1 && payload.push(key);
    });

    setMissingItems(payload);
    setLoading(false);
  };

  useEffect(() => {
    if (selectedRow) {
      findMissing(selectedRow);
    }
  }, [selectedRow]);

  //   {selectedRow.ErrorJson.ErrorMsg}

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth="sm"
      scroll="body"
    >
      <DialogTitle disableTypography>
        <Typography variant="h4">Error Details</Typography>
      </DialogTitle>
      {loading ? (
        <Spinner />
      ) : (
        <DialogContent>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <h5>Invoice:</h5>
              <DialogContentText>{selectedRow.InvoiceNumber}</DialogContentText>
            </div>

            <div>
              <h5>Trigger Action:</h5>
              <DialogContentText>{selectedRow.Action}</DialogContentText>
            </div>
          </div>
          <h5>Error Message:</h5>
          <DialogContentText>
            {JSON.stringify(selectedRow.ErrorJson)}
          </DialogContentText>
          <h5>Missing Items</h5>
          <DialogContentText>
            {missingItems.length === 0 ? 'N/A' : missingItems.join(', ')}
          </DialogContentText>
          <p
            style={{
              fontSize: '0.6rem',
              marginTop: '3rem',
              color: '#6f6f6f',
            }}
          >
            Created: {selectedRow.ErrorTimestamp}
          </p>
        </DialogContent>
      )}
    </Dialog>
  );
}

const errorsColumnsConfig = [
  {
    Header: 'Type',
    accessor: 'ObjectTypeDesc',
    id: 'ObjectTypeDesc',
    width: 70,
  },
  {
    Header: 'Action',
    accessor: 'Action',
    id: 'Action',
    width: 70,
  },
  {
    Header: 'Invoice Number',
    accessor: 'InvoiceNumber',
    id: 'InvoiceNumber',
    width: 80,
  },
  {
    Header: 'Timestamp',
    // accessor: 'ErrorTimestamp',
    accessor: d => format(d.ErrorTimestamp, 'MM/DD/YYYY H:mm:ss'),
    id: 'ErrorTimestamp',
    width: 70,
  },
  {
    Header: 'Message',
    // accessor: 'ErrorTimestamp',
    // accessor: d => d.ErrorJson.ErrorMsg,
    accessor: d => JSON.stringify(d.ErrorJson),
    id: 'ErrorMsg',
    width: 120,
  },
];

const IntegrationErrors = () => {
  return (
    <Observer
      render={() => {
        const history = useHistory();
        const { authStore, dataStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [errors, setErrors] = useState(null);

        const [open, setOpen] = useState(false);
        const [selectedRow, setSelectedRow] = useState(null);

        const handleClick = val => {
          setOpen(true);
          setSelectedRow(val);
        };

        const handleClose = () => {
          setOpen(false);
          setSelectedRow(null);
        };

        const deleteIntegrationErrors = async () => {
          try {
            await authStore.request.delete(
              `${process.env.REACT_APP_API}/api/xer-task-errors`,
            );
            setErrors([]);
          } catch (e) {
            console.error(e);
          }
        };

        const fetchErrors = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/xer-task-errors`,
            );

            const sortedDescendingTimestamps = data.sort(
              (x, y) => new Date(y.ErrorTimestamp) - new Date(x.ErrorTimestamp),
            );
            setErrors(sortedDescendingTimestamps);
          } catch (e) {
            console.error(e);
          }
        };

        useEffect(() => {
          const initialActions = async () => {
            await Promise.all([fetchErrors()]);
            setLoading(false);
          };
          initialActions();
        }, []);
        if (isLoading) return <Spinner />;

        return (
          <FlexDiv>
            <WideBox
              style={{ maxWidth: '1500px', width: '98%' }}
              className="dealsStep1"
            >
              <CustomTable
                data={errors}
                columns={errorsColumnsConfig}
                minRows={1}
                trClassName="react-table-hover-row"
                getTrProps={({ row }) => ({
                  onClick: () => handleClick(row.original),
                })}
                tableHeader={<Typography variant="h2">Errors</Typography>}
                actionables={
                  <ConfirmDialog
                    title="Delete all integration errors?"
                    actions={({ handleClose: hC }) => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          flex: 1,
                        }}
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => {
                            deleteIntegrationErrors();
                            hC();
                          }}
                        >
                          Yes
                        </Button>

                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={() => {
                            hC();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    )}
                  >
                    {({ handleOpen }) => {
                      return (
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleOpen}
                        >
                          Clear Errors
                        </Button>
                      );
                    }}
                  </ConfirmDialog>
                }
                containerStyle={{ padding: '0 2rem' }}
              />
              <SimpleDialog
                open={open}
                onClose={handleClose}
                selectedRow={selectedRow}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default IntegrationErrors;
